<template>
  <div class="contact-page page-container pt-3 pb-4 position-relative">
    <div class="row text-center d-flex justify-content-center">
      <div class="col-lg-10 col-xl-7">
        <div class="row">
          <div class="col-md-4">
            <i class="fa fa-3x fa-map-marker"></i>
            <p class="w-md-50 mx-auto mt-3 font-weight-bold text-blue">
              {{ $t("address") }}
            </p>
          </div>
          <div class="col-md-4">
            <i class="fa fa-3x fa-mobile"></i>
            <p class="w-md-50 mx-auto mt-3 text-blue">
              <b>{{ $t("phone") }}</b>
            </p>
          </div>
          <div class="col-md-4">
            <i class="fa fa-2x fa-envelope"></i>
            <p class="w-md-50 mx-auto mt-3 font-weight-bold text-blue">
              {{ $t("email") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row contact-form-container mt-5">
      <div class="col-12 col-md-6 offset-md-3">
        <div class="mb-5 py-4 px-5 border rounded shadow-sm">
          <h5 class="mb-4 h3">{{ $t("sendMessage") }}</h5>
          <contact-form></contact-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContactFormComponent from "./partials/ContactForm.vue";

export default {
  metaInfo: function () {
    return { title: this.$_t("pages:contact.meta") };
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "contact",
  },
  components: {
    "contact-form": ContactFormComponent,
  },
  data: function () {
    return {
      page: {},
    };
  },
  created: function () {
    this.getData();
  },
  methods: {
    getData: function () {
      // this.$http.get("/api/page/contact-us").then(response => {
      //   this.page = response.data;
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-page {
  .fa {
    border: 3px solid $dark-blue;
    color: $dark-blue;
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 7.5rem;
    line-height: 4.5rem;
  }
}

.contact-form-container {
  background: $white;
  margin-bottom: -1rem;
  h5 {
    color: $dark-blue;
    font-weight: 900;
  }
  .contact-form {
    h5 {
      display: none;
      color: $dark-blue;
      margin-bottom: 2.5rem !important;
    }
    .input-item,
    .textarea-item {
      color: $dark-blue;
      background: transparent;
      border-radius: 0.625rem;
    }
    button {
      color: $dark-blue;
      i {
        color: $dark-blue;
      }
      &:hover {
        background: unset;
      }
    }
  }
}
</style>
